export default __webpack_public_path__ + "static/media/36I-102747_-17355_0.cfa803f7.jpg";